"use strict";import{SplitButton as t}from"./src/SplitButton.js";import{defineElement as e}from"@spectrum-web-components/base/src/define-element.js";e("sp-split-button",t);
//# sourceMappingURL=sp-split-button.js.map
